import { render, staticRenderFns } from "./Edu_contents.vue?vue&type=template&id=25c641d4&"
import script from "./Edu_contents.vue?vue&type=script&lang=js&"
export * from "./Edu_contents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports